// Navbar.jsx - Alternative version with Link
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setIsOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigation = (sectionId) => {
    setIsOpen(false);
    if (location.pathname === '/') {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const handleBookNow = () => {
    // Redirect to phone call
    window.location.href = 'tel:+18334936242';
  };

  const handleLogoClick = () => {
    setIsOpen(false);
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo" onClick={handleLogoClick}>
          <div className="logo-glow"></div>
          <span className="logo-icon">🔧</span>
          <span className="logo-text">Plumber<span className="logo-highlight">Pro</span></span>
        </div>

        {/* Desktop Navigation Links */}
        <ul className="nav-links">
          <li>
            <button 
              className="nav-link-btn"
              onClick={() => handleNavigation('home')}
            >
              <span className="nav-shine"></span>
              Home
            </button>
          </li>
          <li>
            <button 
              className="nav-link-btn"
              onClick={() => handleNavigation('services')}
            >
              <span className="nav-shine"></span>
              Services
            </button>
          </li>
          <li>
            <button 
              className="nav-link-btn"
              onClick={() => handleNavigation('about')}
            >
              <span className="nav-shine"></span>
              About
            </button>
          </li>
          <li>
            <button 
              className="nav-link-btn"
              onClick={() => handleNavigation('contact')}
            >
              <span className="nav-shine"></span>
              Contact
            </button>
          </li>
        </ul>

        {/* Desktop Book Service Now Button - Redirects to phone call */}
        <button className="btn-book-now" onClick={handleBookNow}>
          <span className="btn-shine"></span>
          <span className="btn-content">
            <span className="btn-icon">📋</span>
            Book Service Now
          </span>
          <span className="btn-glow"></span>
        </button>

        {/* Hamburger Menu */}
        <button 
          className={`hamburger ${isOpen ? 'hidden' : ''}`} 
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isOpen ? 'active' : ''}`}>
          <div className="mobile-menu-header">
            <div className="mobile-logo">
              <span className="logo-icon" style={{ fontSize: '1.5rem' }}>🔧</span>
              <span className="logo-text" style={{ fontSize: '1.3rem' }}>
                Plumber<span className="logo-highlight">Pro</span>
              </span>
            </div>
            <button className="mobile-close" onClick={toggleMenu}>
              ✕
            </button>
          </div>
          
          <ul className="mobile-nav-links">
            <li>
              <button 
                className="mobile-nav-btn"
                onClick={() => handleNavigation('home')}
              >
                <span className="mobile-shine"></span>
                🏠 Home
              </button>
            </li>
            <li>
              <button 
                className="mobile-nav-btn"
                onClick={() => handleNavigation('services')}
              >
                <span className="mobile-shine"></span>
                🔧 Services
              </button>
            </li>
            <li>
              <button 
                className="mobile-nav-btn"
                onClick={() => handleNavigation('about')}
              >
                <span className="mobile-shine"></span>
                ℹ️ About
              </button>
            </li>
            <li>
              <button 
                className="mobile-nav-btn"
                onClick={() => handleNavigation('contact')}
              >
                <span className="mobile-shine"></span>
                📬 Contact
              </button>
            </li>
          </ul>

          <div className="mobile-cta-section">
            <button className="mobile-book-btn" onClick={handleBookNow}>
              <span className="mobile-btn-shine"></span>
              📋 Book Service Now
            </button>
            <div className="mobile-phone">
              <span className="mobile-phone-label">📞 Call 24/7</span>
              <a href="tel:+18334936242" className="mobile-phone-number">+1 (833) 493-6242</a>
            </div>
          </div>
        </div>

        {/* Mobile Overlay */}
        {isOpen && <div className="mobile-overlay" onClick={toggleMenu}></div>}
      </div>
    </nav>
  );
};

export default Navbar;